import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

/**
 * React-Replacement the bootstrap data-collapse feature that would normally use jquery
 */
const useBootstrapCollapse = () => {
    // TODO: This works but the closing does sometimes not animate. Maybe there is a ready-to-use package or a better
    //       solution?

    const collapseRef = useRef();
    const collapseSizeRef = useRef();
    const [collapsing, setCollapsing] = useState(false);
    const [showCollapse, setShowCollapse] = useState(false);

    useEffect(() => {
        if (!collapsing) {
            collapseRef.current.style.height = null;

            return;
        }

        if (showCollapse) {
            collapseRef.current.style.height = collapseSizeRef.current.offsetHeight + 'px';
            collapseRef.current.scrollIntoView({
                behavior: 'smooth',
            });
        } else {
            collapseRef.current.style.height = '0px';
        }
    }, [collapsing, showCollapse]);

    function toggleCollapse(event) {
        if (event) {
            event.target.blur();
        }

        if (collapsing) {
            // Let collapsing finish
            return;
        }

        if (showCollapse) {
            // Set base height if we hide the element
            collapseRef.current.style.height = collapseSizeRef.current.offsetHeight + 'px';
        }

        setCollapsing(true);
        setShowCollapse(!showCollapse);

        // Finish collapse after timeout
        setTimeout(() => {
            setCollapsing(false);
        }, 0);
    }

    const collapseClassNames = classNames({
        collapse: !collapsing,
        show: !collapsing && showCollapse,
        collapsing: collapsing,
    });

    return {
        collapseRef,
        collapseSizeRef,
        showCollapse,
        setShowCollapse,
        toggleCollapse,
        collapseClassNames,
    };
};

export default useBootstrapCollapse;
